(function () {
  'use strict';

  var LEVEL_LABELS = {
    'Bra skick': { sv: 'Bra skick', da: 'God stand', en: 'Good condition' },
    'Mycket bra skick': { sv: 'Mycket bra skick', da: 'Meget god stand', en: 'Very good condition' },
    'Utmärkt skick': { sv: 'Utmärkt skick', da: 'Fremragende stand', en: 'Excellent condition' },
    'Som ny': { sv: 'Som ny', da: 'Som ny', en: 'Like new' },
    'Ny': { sv: 'Ny', da: 'Ny', en: 'New' }
  };

  var UI = {
    'scale-label': { sv: 'Skick', da: 'Stand', en: 'Condition' },
    'read-more': { sv: 'Läs mer', da: 'Læs mere', en: 'Read more' },
    'help-skick': { sv: 'Mer om skick', da: 'Mere om stand', en: 'More about condition' },
    'help-behandling': { sv: 'Mer om behandling', da: 'Mere om behandling', en: 'More about treatment' },
    'close': { sv: 'Stäng', da: 'Luk', en: 'Close' }
  };

  function isDanishHost() {
    try {
      var host = String(location.hostname || '').replace(/^www\./i, '').toLowerCase();
      return host === 'soffexpert.dk' || host.endsWith('.soffexpert.dk');
    } catch (e) {
      return false;
    }
  }

  function localeCodeToLang(code) {
    if (!code) return null;
    code = String(code).toLowerCase().split(/[-_]/)[0];
    if (code === 'da' || code === 'nb' || code === 'no') return 'da';
    if (code === 'en') return 'en';
    if (code === 'sv') return 'sv';
    return null;
  }

  function getLang() {
    try {
      if (window.SoffexpertI18n && window.SoffexpertI18n.getLang) {
        var fromI18n = window.SoffexpertI18n.getLang();
        if (fromI18n) return fromI18n;
      }
    } catch (e) {}

    if (isDanishHost()) return 'da';

    try {
      if (window.Shopify) {
        if (Shopify.country === 'DK' || Shopify.country === 'NO') return 'da';
        var shopifyLang = localeCodeToLang(Shopify.locale);
        if (shopifyLang) return shopifyLang;
      }
    } catch (e) {}

    try {
      var htmlLang = localeCodeToLang(document.documentElement.lang);
      if (htmlLang) return htmlLang;
    } catch (e) {}

    try {
      var stored = localStorage.getItem('soffexpert_lang');
      if (stored === 'da' || stored === 'en' || stored === 'sv') return stored;
    } catch (e) {}

    return 'sv';
  }

  function uiText(key, lang) {
    var row = UI[key];
    if (!row) return '';
    return row[lang] || row.sv;
  }

  function levelText(levelKey, lang) {
    if (levelKey === 'Helt ny') levelKey = 'Ny';
    var row = LEVEL_LABELS[levelKey];
    if (!row) return levelKey;
    return row[lang] || row.sv;
  }

  function applySkickI18n(root) {
    var lang = getLang();
    var scopes = [];

    if (root && root.nodeType === 11) {
      scopes.push(root);
    } else if (root && root.nodeType === 1) {
      scopes.push(root);
    } else {
      document.querySelectorAll('.skick-widget').forEach(function (w) {
        scopes.push(w);
      });
    }

    scopes.forEach(function (scope) {
      scope.querySelectorAll('[data-skick-level]').forEach(function (el) {
        el.textContent = levelText(el.getAttribute('data-skick-level'), lang);
      });

      scope.querySelectorAll('[data-skick-i18n]').forEach(function (el) {
        var key = el.getAttribute('data-skick-i18n');
        var text = uiText(key, lang);
        if (!text) return;
        if (el.hasAttribute('aria-label') || key === 'scale-label') {
          el.setAttribute('aria-label', text);
        } else {
          el.textContent = text;
        }
      });

      scope.querySelectorAll('template').forEach(function (template) {
        if (template.content) applySkickI18n(template.content);
      });
    });
  }

  function openSkickPopup(popupId) {
    var existing = document.getElementById(popupId);
    if (existing) existing.remove();
    var template = document.getElementById('skick-popup-template-' + popupId);
    if (!template) return;
    var clone = template.content.cloneNode(true);
    document.body.appendChild(clone);
    applySkickI18n(document.getElementById(popupId));
    document.body.style.overflow = 'hidden';
  }

  function closeSkickPopup(event, popupId) {
    if (event && event.target !== event.currentTarget) return;
    var popup = document.getElementById(popupId);
    if (!popup) return;
    popup.classList.add('is-closing');
    setTimeout(function () {
      popup.remove();
      document.body.style.overflow = '';
    }, 350);
  }

  window.openSkickPopup = openSkickPopup;
  window.closeSkickPopup = closeSkickPopup;
  window.__applySkickI18n = applySkickI18n;

  document.addEventListener('keydown', function (e) {
    if (e.key !== 'Escape') return;
    var overlay = document.querySelector('.skick-popup-overlay');
    if (!overlay) return;
    overlay.classList.add('is-closing');
    setTimeout(function () {
      overlay.remove();
      document.body.style.overflow = '';
    }, 350);
  });

  function scheduleApply() {
    applySkickI18n();
    [50, 250, 1000].forEach(function (ms) {
      setTimeout(applySkickI18n, ms);
    });
  }

  function boot() {
    scheduleApply();
    document.addEventListener('soffexpert:langchange', applySkickI18n);

    if (typeof MutationObserver !== 'undefined') {
      var timer = null;
      var observer = new MutationObserver(function (mutations) {
        var touched = false;
        mutations.forEach(function (m) {
          m.addedNodes.forEach(function (node) {
            if (node.nodeType !== 1) return;
            if (node.classList && node.classList.contains('skick-widget')) touched = true;
            else if (node.querySelector && node.querySelector('.skick-widget')) touched = true;
          });
        });
        if (!touched) return;
        clearTimeout(timer);
        timer = setTimeout(applySkickI18n, 50);
      });
      observer.observe(document.documentElement, { childList: true, subtree: true });
    }
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();
